import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="relative">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">

        {/* Top area: Blocks */}
        <div className="grid md:grid-cols-2 gap-x-14 gap-y-6 py-8 md:py-12 border-t border-blue-200 place-items-stretch">

          {/* 1st block */}
          <div className="md:col-span-1 md:text-right col-span-2 text-center">
            <ul className="text-m">
              <li className="mb-2">
                <Link to="#" className="text-gray-200 filter opacity-60 hover:opacity-90  transition duration-300 ease-in-out">
                  <img className="inline-block mr-2 filter invert" width="32" viewBox="0 0 512 512" alt="" src={require('../images/icons/envelope.svg').default}/>
                  info@tahetrukk.ee
                </Link>
              </li>
            </ul>
          </div>

          {/* 2nd block */}
          <div className="md:col-span-1 md:text-left col-span-2 text-center">
            <ul className="text-m">
              <li className="mb-2">
                <Link to="#" className="text-gray-200 filter opacity-60 hover:opacity-90 transition duration-150 ease-in-out">
                  <img className="inline-block mr-2 filter invert " width="32" viewBox="0 0 512 512" alt="" src={require('../images/icons/phone.svg').default}/>
                  +372 5016449
                </Link>
              </li>
            </ul>
          </div>

        </div>

        {/* Bottom area */}
        <div className="md:flex md:items-center md:justify-between py-4 md:py-8 border-t border-blue-200">

          {/* Social links */}
          <ul className="flex mb-4 md:order-1 md:ml-4 md:mb-0">
            
            {/* Storybook */}
            <li className="ml-4">
              <Link to={{pathname:"https://scorestorybook.ee/11027918-TAHETRUKK-OU/koondraport"}} target="_blank" className="filter invert opacity-60 hover:opacity-90 transition duration-150 ease-in-out" aria-label="Storybook">
                <img className="inline-block mr-2" width="16" viewBox="0 0 512 512" alt="" src={require('../images/icons/storybook.svg').default}/>
              </Link>
            </li>

            {/* Facebook */}
            <li className="ml-4">
              <Link to={{pathname:"https://www.facebook.com/tahetrukk"}} target="_blank" className="filter invert opacity-60 hover:opacity-90 transition duration-150 ease-in-out" aria-label="Facebook">
                <img className="inline-block mr-2" width="16" viewBox="0 0 512 512" alt="" src={require('../images/icons/facebook_f.svg').default}/>
              </Link>
            </li>
            
          </ul>

          {/* Copyrights note */}
          <div className="text-sm text-gray-200 opacity-70 mr-4">Tähetrükk OÜ &copy; 2022</div>

        </div>
      </div>
    </footer>
  );
}

export default Footer;
